import { render, staticRenderFns } from "./ReadOnlyJob.vue?vue&type=template&id=b31258da&scoped=true"
import script from "./ReadOnlyJob.vue?vue&type=script&lang=js"
export * from "./ReadOnlyJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31258da",
  null
  
)

export default component.exports